import { lazyRouteComponent } from "@tanstack/react-router";
import { DIGITAL_SERVICES_FAQS, SERVICE_PACKAGES } from "@/components/DigitalServices";

export const PAGE_URL = "https://alkoholprovet.se/digitala-tjanster";
export const OG_IMAGE = "https://alkoholprovet.se/og/default.jpg";
export const TITLE = "Digitala tjänster för restaurang och bar 2026";

export const DESCRIPTION =
  "Google-företagsprofil, hemsida med bokning, digital meny och sociala medier för restaurang, bar och café. Fast pris från 2 900 kr. Levereras av Deniro Holdings.";

const DigitalServicesPage = lazyRouteComponent(() => import("./digitala-tjanster.view"), "DigitalServicesPage");

export const routeOptions = {
  component: DigitalServicesPage,
  head: () => ({
    meta: [
      { title: "Digitala tjänster för restaurang & bar – Google, hemsida, bokning" },
      { name: "description", content: DESCRIPTION },
      { property: "og:type", content: "website" },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:url", content: PAGE_URL },
      { property: "og:image", content: OG_IMAGE },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: DESCRIPTION },
      { name: "twitter:image", content: OG_IMAGE },
    ],
    links: [{ rel: "canonical", href: PAGE_URL }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Service",
          name: TITLE,
          description: DESCRIPTION,
          url: PAGE_URL,
          serviceType: "Digital marknadsföring för restaurang och bar",
          areaServed: { "@type": "Country", name: "Sverige" },
          provider: {
            "@type": "Organization",
            name: "Deniro Holdings",
            url: "https://alkoholprovet.se",
          },
          inLanguage: "sv-SE",
          offers: SERVICE_PACKAGES.map((p) => ({
            "@type": "Offer",
            name: p.name,
            price: p.price.replace(/[^0-9]/g, ""),
            priceCurrency: "SEK",
            availability: "https://schema.org/InStock",
            url: PAGE_URL,
          })),
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          inLanguage: "sv-SE",
          mainEntity: DIGITAL_SERVICES_FAQS.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        }),
      },
    ],
  }),
};
